import { render, staticRenderFns } from "./cohorts.vue?vue&type=template&id=2a58a1ec&scoped=true&"
import script from "./cohorts.vue?vue&type=script&lang=js&"
export * from "./cohorts.vue?vue&type=script&lang=js&"
import style0 from "./cohorts.vue?vue&type=style&index=0&id=2a58a1ec&lang=scss&scoped=true&"
import style1 from "./cohorts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58a1ec",
  null
  
)

export default component.exports